import Vue from 'vue'
import Router from 'vue-router'
import MainIndex from '@/pages/index'
import Index from '@/pages/index/index'
import End from '@/pages/end'
import Evn from '@/pages/evn/index'
import List from '@/pages/evn/List'
import Content from '@/pages/evn/Content'
import Detail from '@/pages/evn/Detail'
import Dfile from '@/pages/evn/Dfile'
import Search from '@/pages/search/index'
import Enroll from '@/pages/enroll/entrance'
import EnrollIndex from '@/pages/enroll/index'
import EnrollArticle from '@/pages/enroll/goArticle'
import EnrollContent from '@/pages/enroll/articleContent'
import EnrollList from '@/pages/enroll/list'
import EnrollDetail from '@/pages/enroll/detail'
import Disc from '@/pages/index/disc'
import Sign from '@/pages/sign'
import SignSearch from '@/pages/signSearch'
import Reg from '@/pages/reg'
import Admission from '@/pages/admission'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // routes: [
  //   {
  //     path:'*',
  //     name: 'End',
  //     component: End,
  //   },
  // ],
  routes: [
    {
      path:'/sign',
      name: 'Sign',
      component: Sign,
    },
    {
      path:'/sign-search',
      name: 'SignSearch',
      component: SignSearch,
    },
    {
      path:'/reg',
      name: 'Reg',
      component: Reg,
    },
    {
      path:'/admission',
      name: 'Admission',
      component: Admission,
    },
    {
      path: '/',
      name: 'MainIndex',
      component: MainIndex,
      children:[
        {
          path:'index',
          component:Index,
        },
        {
          path:'disc',
          component:Disc,
        },
        {
          path:'evn',
          component:Evn,
          children:[
            {
              path:'list',
              component:List,
            },
            {
              path:'content',
              component:Content,
            },
            {
              path:'detail',
              component:Detail,
            },
            {
              path:'Dfile',
              component:Dfile,
            },
            {
              path:'/',
              redirect:'content',
            },
          ],
        },
        {
          path:'/',
          redirect:'Index',
        },
      ],
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
    },
    {
      path: '/enroll',
      name: 'Enroll',
      component: Enroll,
      children:[
        {
          path:'/',
          redirect:'index',
        },
        {
          path:'index',
          component:EnrollIndex,
        },
        {
          path:'article',
          component:EnrollArticle,
          children:[
            {
              path:'/',
              redirect:'list',
            },
            {
              path:'content',
              component:EnrollContent,
            },
            {
              path:'detail',
              component:EnrollDetail,
            },
            {
              path:'list',
              component:EnrollList,
            },
          ],
        },
      ],
    },

    // {
    //   path: '/ii',
    //   name: 'Index',
    //   component: Index,
    //   children:[
    //     {
    //       path: 'msg1',
    //       component: Msg1,
    //     },
    //     {
    //       path: 'msg2',
    //       component: Msg2,
    //     },
    //     {
    //       path: '/',
    //       redirect:'msg1',
    //     },
    //
    //   ],
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js